import React from "react";
import { useMutation } from "react-query";
import { updateOfficeStatus } from "../../../../../actions/Utilities/OfficeStatus";
import { toast } from "../../../../../components/toastNotification";
import { OfficeStatusType } from "../types";
import { editStateOfficeStatus, officeStatusReFetching } from "../atoms/atoms";
import { useRecoilState, useSetRecoilState } from "recoil";

export default function useUpdateOfficeStatus() {
  const setActionEditState = useSetRecoilState(editStateOfficeStatus);
  const [isReFetching, setIsReFetching] = useRecoilState(
    officeStatusReFetching
  );
  
  const { mutate } = useMutation(
    (OfficeStatus: OfficeStatusType) => updateOfficeStatus(OfficeStatus),
    {
  
      onSuccess: (res) => {
        if (typeof res == "object") {
          toast.fire(
            "Updating Office Status failed",
            `${res.Message}`,
            "error"
          );
        } else {
        switch (true) {
          case res == "Success":
            toast.fire(
              "Success",
              "Office Status Updated Successfully",
              "success"
            );
            break;
          case res.includes("Notification insert Failed!"):
            toast.fire(
              "Success ",
              `Office Status Updated Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res.includes("Operation Failed!"):
            toast.fire(
              "Updating Office Status failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res.includes("The data already exists!"):
            toast.fire(
              "Updating Office Status failed ",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
            case res.includes("Office Status not found"):
            toast.fire(
                "Updating Office Status failed ",
                `Error: ${res}`,
                "error"
            );
            break;
            case res.includes("Action object is null"):
            toast.fire(
                "Updating Office Status failed ",
                `Error: ${res}`,
                "error"
            );
            break;
          default:
            toast.fire(
              "Updating Office Status failed",
              `${res.Message}`,
              "error"
            );
        }
      }
        // Redirect to View
        setActionEditState(false);
        
        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire("Update Office Status failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
}
